import { useEffect, useState } from "react";
import useHttpFetch from "./useHttpFetch";
import readEnumsFromIndexedDB from "../utils/cache/Enums/readEnumsFromIndexedDB";
import storeEnumsInIndexedDB from "../utils/cache/Enums/storeEnumsInIndexedDB";

const useEnum = (enumKeyNamesStr, language, calType) => {
  const [enumOptions, setEnumOptions] = useState(() =>
    enumKeyNamesStr?.split(",")?.map((keyName) => ({ [keyName]: [] }))
  );
  const { isLoading: enumOptionsAreLoading, sendRequest: sendEnumReqFetch } = useHttpFetch();

  useEffect(() => {
    if (enumKeyNamesStr) {
      const getEnumsViaApi = async () => {
        // console.log("language", language);
        // console.log("calType", calType);
        const result = await sendEnumReqFetch({
          url: `source/enum?enums=${enumKeyNamesStr}`,
          language,
          calType,
        });
        if (result.resIsOk) {
          await storeEnumsInIndexedDB(result?.response);
          return result.response;
        }
      };

      const findEnumOptions = async () => {
        let fetchedFieldAccesses = {};
        const { foundedEnums, notFoundedEnumKeyNames } = await readEnumsFromIndexedDB(enumKeyNamesStr);
        if (notFoundedEnumKeyNames?.length > 0) {
          fetchedFieldAccesses = await getEnumsViaApi(notFoundedEnumKeyNames?.join(","));
        }
        // console.log("foundedEnums : ", foundedEnums);
        // console.log("fetchedFieldAccesses : ", fetchedFieldAccesses);
        // console.log("notFoundedEnumKeyNames : ", notFoundedEnumKeyNames);
        const responses = { ...foundedEnums, ...fetchedFieldAccesses };
        setEnumOptions(responses);
      };

      findEnumOptions();
    }
  }, []);

  return enumKeyNamesStr
    ? { enumOptions, enumOptionsAreLoading }
    : { enumOptions: null, enumOptionsAreLoading: null };
};

export default useEnum;
